/* eslint-disable @typescript-eslint/no-magic-numbers */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormMoney", {
    enumerable: true,
    get: function() {
        return FormMoney;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _Theme = require("../../../contexts/Theme");
const _Tooltip = require("../../Tooltip/Tooltip");
const _adminicons = require("../../../admin-icons");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const convertStringToNumber = (target)=>{
    if (target == null || target === "") {
        return null;
    }
    const convert = Number(target);
    return Number.isNaN(convert) ? null : convert;
};
const format = (inputValue)=>{
    const convert = convertStringToNumber(inputValue);
    return convert === null || convert === void 0 ? void 0 : convert.toFixed(2);
};
const FormMoney = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors, animationDuration } = (0, _Theme.useTheme)();
    const [internalValue, setInternalValue] = (0, _react.useState)("");
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded: props.rounded
    });
    const padding = (0, _useInputPadding.useInputPadding)();
    const lineHeight = (0, _react.useMemo)(()=>props.variant === "lg" ? "24px" : "22px", [
        props.variant
    ]);
    const applyMinMax = (value)=>{
        const numericValue = convertStringToNumber(value);
        if (numericValue != null) {
            if (props.min != null && numericValue < Number(props.min)) {
                return Number(props.min);
            }
            if (props.max != null && numericValue > Number(props.max)) {
                return Number(props.max);
            }
        }
        return numericValue;
    };
    // Catching each input press
    const numbersOnlyKeyDownEventListener = (e)=>{
        if (// Allow ctrl/option/command keys.
        e.metaKey || e.code === "Backspace" || e.code === "ArrowUp" || e.code === "ArrowDown" || e.code === "ArrowLeft" || e.code === "ArrowRight" || e.code === "Tab") {
            return;
        }
        // Prevent input if it's not a digit or a decimal point,
        // or if there's already a decimal point in the input field.
        if (!/^\d$/u.test(e.key) && (e.key !== "." || e.currentTarget.value.includes("."))) {
            e.preventDefault();
        }
    };
    // Catching paste operation
    const numbersOnlyOnInputEventListener = (e)=>{
        let encounteredDecimalPoint = false;
        e.currentTarget.value = e.currentTarget.value.replace(/[^\d.]+/gu, "") // Allow only digits and a single period
        .replace(/\./gu, (m)=>{
            if (m === "." && !encounteredDecimalPoint) {
                encounteredDecimalPoint = true;
                return m;
            } else {
                return "";
            }
        }); // Remove all but the first decimal point
    };
    var _props_className, _props_currencyPrefix, _props_id, _props_value;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "5074a47e3794d75",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    lineHeight,
                    animationDuration,
                    colors.muted1
                ]
            ]
        ]) + " " + "input-money ".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(borderCss.className)
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "5074a47e3794d75",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    lineHeight,
                    animationDuration,
                    colors.muted1
                ]
            ]
        ]) + " " + "currency"
    }, (_props_currencyPrefix = props.currencyPrefix) !== null && _props_currencyPrefix !== void 0 ? _props_currencyPrefix : null, props.currency), /*#__PURE__*/ _react.default.createElement("input", {
        ...props,
        type: "text",
        ref: ref,
        id: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        "aria-describedby": hintId,
        value: // I can't put this on the state init, when I save and back to form,
        // it has 2 values, and it picked the old value.
        internalValue === "" ? format("".concat((_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : "")) : internalValue,
        onChange: (e)=>{
            setInternalValue(e.currentTarget.value);
            if (props.onChange != null) {
                var _applyMinMax;
                var _applyMinMax_toString;
                e.currentTarget.value = (_applyMinMax_toString = (_applyMinMax = applyMinMax(e.currentTarget.value)) === null || _applyMinMax === void 0 ? void 0 : _applyMinMax.toString()) !== null && _applyMinMax_toString !== void 0 ? _applyMinMax_toString : "";
                props.onChange(e);
            }
        },
        onBlur: (e)=>{
            var _applyMinMax;
            var _format;
            setInternalValue((_format = format((_applyMinMax = applyMinMax(e.currentTarget.value)) === null || _applyMinMax === void 0 ? void 0 : _applyMinMax.toString())) !== null && _format !== void 0 ? _format : "");
            if (props.onBlur != null) {
                props.onBlur(e);
            }
        },
        onKeyDown: (e)=>{
            numbersOnlyKeyDownEventListener(e);
            if (props.onKeyDown != null) {
                props.onKeyDown(e);
            }
        },
        onInput: (e)=>{
            numbersOnlyOnInputEventListener(e);
            if (props.onInput != null) {
                props.onInput(e);
            }
        },
        className: _style.default.dynamic([
            [
                "5074a47e3794d75",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    lineHeight,
                    animationDuration,
                    colors.muted1
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }), props.tooltip != null && /*#__PURE__*/ _react.default.createElement(_Tooltip.Tooltip, {
        placement: "top",
        title: props.tooltip
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "5074a47e3794d75",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    lineHeight,
                    animationDuration,
                    colors.muted1
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_adminicons.RiInformationLine, {
        color: colors.grayscale[60],
        size: 16
    })))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "5074a47e3794d75",
        dynamic: [
            padding.shorthand,
            props.variant === "lg" ? "16px" : "14px",
            lineHeight,
            animationDuration,
            colors.muted1
        ]
    }, ".input-money.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:".concat(padding.shorthand, ";font-size:").concat(props.variant === "lg" ? "16px" : "14px", "!important;line-height:").concat(lineHeight, "!important}input.__jsx-style-dynamic-selector{border:0;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;cursor:pointer;outline:none;-webkit-transition:").concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border;width:100%;position:relative;background:#fff}input.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector:-moz-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::-moz-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector:-ms-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::-ms-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::placeholder{color:").concat(colors.muted1, "}")), borderCss.styles);
});
FormMoney.displayName = "FormMoney";

//# sourceMappingURL=FormMoney.js.map